export function inviteUser(send) {
  return (body, ...args) =>
    send(
      {
        path: '/v2/users/invite',
        pathParameters: {},
        type: 'post',
        query: undefined,
        body: body,
        headers: undefined,
        auth: 'oauth2',
        contentType: 'application/json',
      },
      ...args
    );
}
